import db from '@/components/firebase/init'
const firebase = require('firebase')
const axios = require('axios')

export const toolboxMixin = {
  data () {
    return {
      geoIpDbKey: process.env.GEOIP_DB_KEY
    }
  },
  methods: {
    async refreshCurrentUser () {
      let user = firebase.auth().currentUser
      await user.reload()
      await user.getIdTokenResult(true)
    },
    async getCurrentUser () {
      let user = firebase.auth().currentUser
      let tokenResult = await user.getIdTokenResult()
      console.log('tokenResult')
      console.log(tokenResult)
      user.accountId = tokenResult.claims.accountId
      return user
    },
    async getCurrentUserDetails () {
      let user = await this.getCurrentUser()
      let doc = await db.collection('users').doc(user.uid).get()
      return {
        data: doc.data(),
        id: doc.id
      }
    },
    async getCurrentAccount () {
      let user = await this.getCurrentUserDetails()
      console.log('in getCurrentUser function')
      console.log(user)
      let doc = await db.collection('accounts').doc(user.accountId).get()
      return {
        data: doc.data(),
        id: doc.id
      }
    },
    async getAuthDetails () {
      let authDetails = {
        userAuth: null,
        user: null,
        account: null
      }
      authDetails.userAuth = firebase.auth().currentUser
      let userDoc = await db.collection('users').doc(authDetails.userAuth.uid).get()
      console.log('userDoc in toolbox')
      console.log(userDoc)
      if (userDoc.data()) {
        console.log('we think user doc exists')
        authDetails.user = {
          id: userDoc.id,
          data: userDoc.data()
        }
        let accountDoc = await db.collection('accounts').doc(userDoc.data().accountId).get()
        authDetails.account = {
          id: accountDoc.id,
          data: accountDoc.data()
        }
      }
      return authDetails
    },
    prettyV2Code (code) {
      let fullCode = '0002' + code
      let prettyCode = [ fullCode.slice(0, 9), '-', fullCode.slice(9, 18), '-', fullCode.slice(18, 27), '-', fullCode.slice(27) ].join('')
      return prettyCode
    },
    async getClientIp () {
      let ipData = await axios.get(process.env.API_BASE_URL + 'getClientIp')
      console.log(ipData)
      return ipData.data.ipAddress
    },
    async getClientIpData () {
      // request accurate info from user (annoying popup)
      // navigator.geolocation.getCurrentPosition(function (position) {
      //   console.log(position.coords.latitude, position.coords.longitude)
      // })
      // axios.get('http://ip-api.com/json')
      try {
        let ipApiResult = await this.getClientIpDataIpApi()
        console.log(ipApiResult)
        let geoipDbResult = await this.getClientIpDataGeoipDb()
        console.log(geoipDbResult)
        return ipApiResult
      } catch (error) {
        return null
      }
    },
    async getClientIpDataIpApi () {
      let result = await axios.get('http://ip-api.com/json')
      if (result === null) return null
      let clientIpData = {
        IpV4: result.data.query,
        lat: result.data.lat,
        lon: result.data.lon,
        country: result.data.country,
        countryCode: result.data.countryCode,
        regionState: result.data.region,
        regionStateName: result.data.regionName,
        city: result.data.city,
        zip: result.data.zip,
        isp: result.data.isp,
        timezone: result.data.timezone
      }
      return clientIpData
    },
    async getClientIpDataGeoipDb () {
      let result = await axios.get('https://geoip-db.com/json/' + this.geoIpDbKey)
      if (result === null) return null
      let clientIpData = {
        IpV4: result.data.IPv4,
        lat: result.data.latitude,
        lon: result.data.longitude,
        country: result.data.country_name,
        countryCode: result.data.country_code,
        regionState: null,
        regionStateName: result.data.state,
        city: result.data.city,
        zip: result.data.postal,
        isp: null,
        timezone: null
      }
      return clientIpData
    },
    showNotify (message, type = '', title = '', icon = '',
            verticalAlign = 'top', horizontalAlign = 'right') {
      // type: ['', 'info', 'success', 'warning', 'danger']
      var msg = title === '' ? `<span>${message}</span>` : `<span><b>${title} - </b>${message}</span>`
      this.$notify(
        {
          component: {
            template: msg
          },
          icon: icon,
          horizontalAlign: horizontalAlign,
          verticalAlign: verticalAlign,
          type: type === '' ? 'info' : type
        })
    },
    firestoreTimeNow () {
      return firebase.firestore.FieldValue.serverTimestamp()
    },
    async prodImgUrl (prodId, prodData, sizeString) {
      // sizeString ex: '140x140'
      console.log('getting prod image url size ', sizeString)
      try {
        if (sizeString) {
          let fsString = prodData.imageUrl.split('/').pop()
          let fsPieces = fsString.split('%2F')
          fsPieces[fsPieces.length - 1] = fsPieces[fsPieces.length - 1].split('?').shift()
          let fileParts = fsPieces[fsPieces.length - 1].split('.')
          let ext = fileParts.pop()
          fsPieces[fsPieces.length - 1] = fileParts.join('.') + '_' + sizeString + '.' + ext
          console.log('parts', fsPieces)
          let fullPath = fsPieces.join('/')
          console.log('fullPath', fullPath)
          var storageRef = firebase.storage().ref()
          return storageRef.child(fullPath).getDownloadURL().then(foundUrl => {
            console.log('image found, returning', foundUrl)
            return foundUrl
          }, error => {
            console.log(error)
            return prodData.imageUrl
          })
        } else {
          console.log('sizeString determined to not be provided so returning default url')
          return prodData.imageUrl
        }
      } catch (err) {
        console.log(err)
        return prodData.imageUrl
      }
    },
    async brandImgUrl (brandId, brandData, sizeString) {
      // sizeString ex: '140x140'
      console.log('getting brand image url size ', sizeString)
      try {
        if (sizeString) {
          let fsString = brandData.logoUrl.split('/').pop()
          let fsPieces = fsString.split('%2F')
          fsPieces[fsPieces.length - 1] = fsPieces[fsPieces.length - 1].split('?').shift()
          let fileParts = fsPieces[fsPieces.length - 1].split('.')
          let ext = fileParts.pop()
          fsPieces[fsPieces.length - 1] = fileParts.join('.') + '_' + sizeString + '.' + ext
          console.log('parts', fsPieces)
          let fullPath = fsPieces.join('/')
          console.log('fullPath', fullPath)
          var storageRef = firebase.storage().ref()
          return storageRef.child(fullPath).getDownloadURL().then(foundUrl => {
            console.log('image found, returning', foundUrl)
            return foundUrl
          }, error => {
            console.log(error)
            return brandData.logoUrl
          })
        } else {
          console.log('sizeString determined to not be provided so returning default url')
          return brandData.logoUrl
        }
      } catch (err) {
        console.log(err)
        return brandData.logoUrl
      }
    },
    async retailerImgUrl (retailerId, retailerData, sizeString) {
      // sizeString ex: '140x140'
      console.log('getting retailer image url size ', sizeString)
      try {
        if (sizeString) {
          let fsString = retailerData.logoUrl.split('/').pop()
          let fsPieces = fsString.split('%2F')
          fsPieces[fsPieces.length - 1] = fsPieces[fsPieces.length - 1].split('?').shift()
          let fileParts = fsPieces[fsPieces.length - 1].split('.')
          let ext = fileParts.pop()
          fsPieces[fsPieces.length - 1] = fileParts.join('.') + '_' + sizeString + '.' + ext
          console.log('parts', fsPieces)
          let fullPath = fsPieces.join('/')
          console.log('fullPath', fullPath)
          var storageRef = firebase.storage().ref()
          return storageRef.child(fullPath).getDownloadURL().then(foundUrl => {
            console.log('image found, returning', foundUrl)
            return foundUrl
          }, error => {
            console.log(error)
            return retailerData.logoUrl
          })
        } else {
          console.log('sizeString determined to not be provided so returning default url')
          return retailerData.logoUrl
        }
      } catch (err) {
        console.log(err)
        return retailerData.logoUrl
      }
    },
    downloadCsv (csvString, saveAsName) {
      var blob = new Blob([csvString])
      if (window.navigator.msSaveOrOpenBlob) { // IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
        window.navigator.msSaveBlob(blob, saveAsName)
      } else {
        var a = window.document.createElement('a')
        a.href = window.URL.createObjectURL(blob, {type: 'text/plain'})
        a.download = saveAsName
        document.body.appendChild(a)
        a.click()  // IE: "Access is denied"; see: https://connect.microsoft.com/IE/feedback/details/797361/ie-10-treats-blob-url-as-cross-origin-and-denies-access
        document.body.removeChild(a)
      }
    },
    productNameForLabel (productData) {
      let str = productData.name
      if (productData.size) {
        str = str + ' ' + productData.size
      }
      if (productData.color) {
        str = str + ' ' + productData.color
      }
      if (productData.style) {
        str = str + ' ' + productData.style
      }
      if (str.length > 35) {
        str = str.substring(0, 35)
      }
      return str
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/toolboxMixin.js